if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      // KAVERO MOD START: cerrar el visor con un toque (movil)
      // Va en connectedCallback, no en el constructor: al construirse un custom
      // element sus hijos pueden no existir todavia y querySelector devolveria null,
      // lo que romperia el elemento entero y dejaria el zoom sin abrir.
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();
        if (this.kvTapBound) return;
        const content = this.querySelector('.product-media-modal__content');
        if (!content) return;
        this.kvTapBound = true;
        let touchGesture = null;

        content.addEventListener(
          'touchstart',
          (event) => {
            if (touchGesture) {
              if (event.touches.length > 1) touchGesture.hadMultipleTouches = true;
              return;
            }

            const touch = event.touches[0];
            touchGesture = {
              startX: touch.clientX,
              startY: touch.clientY,
              startedAt: Date.now(),
              maxDistance: 0,
              hadMultipleTouches: event.touches.length > 1,
            };
          },
          { passive: true }
        );

        content.addEventListener(
          'touchmove',
          (event) => {
            if (!touchGesture) return;
            if (event.touches.length > 1) touchGesture.hadMultipleTouches = true;

            const touch = event.touches[0];
            if (!touch) return;

            touchGesture.maxDistance = Math.max(
              touchGesture.maxDistance,
              Math.hypot(touch.clientX - touchGesture.startX, touch.clientY - touchGesture.startY)
            );
          },
          { passive: true }
        );

        content.addEventListener(
          'touchend',
          (event) => {
            if (!touchGesture) return;
            if (event.touches.length > 0) {
              touchGesture.hadMultipleTouches = true;
              return;
            }

            const gesture = touchGesture;
            touchGesture = null;
            const touch = event.changedTouches[0];
            const endDistance = touch
              ? Math.hypot(touch.clientX - gesture.startX, touch.clientY - gesture.startY)
              : 0;
            const targetIsCloseButton =
              event.target.closest && event.target.closest('.product-media-modal__toggle');

            if (
              !targetIsCloseButton &&
              !gesture.hadMultipleTouches &&
              Math.max(gesture.maxDistance, endDistance) < 10 &&
              Date.now() - gesture.startedAt < 350
            ) {
              this.hide();
            }
          },
          { passive: true }
        );

        content.addEventListener(
          'touchcancel',
          () => {
            touchGesture = null;
          },
          { passive: true }
        );
              }
      // KAVERO MOD END

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
